import ApiService from "../../services/ApiService";
import translate from "../../services/Translate";

export const fetchProjectWorkload = (
  setWorkload: Function,
  setIsLoading: Function,
  onlyActive: boolean,
  language: string
) => {
  setIsLoading(true);

  ApiService.get(`projects/workload?order=desc&only_active=${onlyActive}`)
    .then((response) =>
      setWorkload(
        response.data.projects_workload.map((element: any, index: number) => ({ ...element, index: index + 1 }))
      )
    )
    .catch((error) => {
      console.error("Error fetching projects workload:", error);
      alert(translate(language, "ERROR.API_ERROR"));
    })
    .finally(() => setIsLoading(false));
};
